import { useCallback } from 'react';

import { useCourse } from '../../courseContext';
import CourseEntity from '../../entity/Course';
import { useCourseViewerContext } from '../../views/CourseViewer/context';
import useCourseAvailability from '../../views/CourseViewer/hooks/useCourseAvailability';
import { getAdjacentLessons } from '../../views/CourseViewer/utils';
import useCourseNavigation from '../useCourseNavigation';

export const useNextLesson = () => {
  const { lessons, lessonPageId, course } = useCourse();
  const { lockSettings, onLessonChange, contentPerformance } = useCourseViewerContext();
  const { navigate } = useCourseNavigation(CourseEntity.id(course), onLessonChange);
  const { getAvailability } = useCourseAvailability();
  const { nextLesson, currentLesson, prevLesson } = getAdjacentLessons(lessonPageId, lessons);
  const currentLessonBlockId = currentLesson?.blockId;
  const progress = contentPerformance?.[currentLessonBlockId!]?.lessonPagePerformance;

  const isNextLessonAvailable =
    nextLesson?.blockId && getAvailability(lockSettings[nextLesson.blockId]) && progress === 100;

  const onNextLessonClick = useCallback(() => {
    navigate(nextLesson?.id, undefined, undefined);
  }, [navigate, nextLesson?.id]);

  return {
    prevLesson,
    nextLesson,
    currentLesson,
    isNextLessonAvailable,
    onNextLessonClick,
  };
};
